import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
  selector: 'aggregator-dashboard-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss',
  standalone: true,
  imports: [],
})
export class DashboardBarChartComponent implements OnInit {
  @ViewChild('lineChartRef', { static: true })
  chartCanvas!: ElementRef<HTMLCanvasElement>;

  chart!: Chart;

  ngOnInit(): void {
    this.createChart();
  }

  createChart(): void {
    // Get the 2D context of the canvas
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (!ctx) {
      return;
    }

    // Create a new Chart instance
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Август',
          'Сентябрь',
          'Ноябрь',
          'Декабрь',
        ],
        datasets: [
          {
            label: 'Количество',
            data: [
              450000, 890000, 230000, 500000, 320000, 439310, 400120, 560000, 690000, 510000,
              710000, 483000,
            ],
            backgroundColor: ['#02be69', '#02be69', '#02be69', '#02be69'],
            borderColor: ['#02be69', '#02be69', '#02be69', '#02be69'],
            borderRadius: 4,
            barThickness: 18,
          },
        ],
      },
      options: {
        interaction: {
          mode: 'index',
          intersect: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false, // Hide the legend
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
          x: {
            grid: {
              display: false, // Hide vertical grid lines
            },
          },
        },
      },
    });
  }
}
